export enum DemandState {
    Open = 'OPEN',
    NoDemand = 'NO_DEMAND',
    DemandReported = 'DEMAND_REPORTED',
    ClosedNoDemand = 'CLOSED_NO_DEMAND',
    ClosedWithDemand = 'CLOSED_WITH_DEMAND',
}
